import getApp from '../firebase'
import { useCallback } from 'react'

const useDeleteDocument = (collection: string) =>
  useCallback((id: string) => getApp().firestore().collection(collection).doc(id).delete(), [collection])
export default useDeleteDocument
